import PropTypes from 'prop-types'
import { forwardRef, useCallback, useImperativeHandle, useRef, useState } from 'react'

import { Button } from '@/components/elements/button'
import { Input } from '@/components/elements/input'
import { Label } from '@/components/elements/label'
import { Switch } from '@/components/elements/switch'
import { cn } from '@/utils/helpers'

export const LinkEditBlock = forwardRef(
  ({ onSave, defaultIsNewTab, defaultUrl, defaultText, className }, ref) => {
    const formRef = useRef(null)
    const [url, setUrl] = useState(defaultUrl || '')
    const [text, setText] = useState(defaultText || '')
    const [isNewTab, setIsNewTab] = useState(defaultIsNewTab || false)

    const handleSave = useCallback(
      (e) => {
        e.preventDefault()
        if (formRef.current) {
          const isValid = Array.from(formRef.current.querySelectorAll('input')).every((input) =>
            input.checkValidity(),
          )

          if (isValid) {
            onSave(url, text, isNewTab)
          } else {
            formRef.current.querySelectorAll('input').forEach((input) => {
              if (!input.checkValidity()) {
                input.reportValidity()
              }
            })
          }
        }
      },
      [onSave, url, text, isNewTab],
    )

    useImperativeHandle(ref, () => formRef.current)

    return (
      <div ref={formRef}>
        <div className={cn('space-y-4', className)}>
          <div className="space-y-2">
            <Label>URL</Label>
            <Input
              type="url"
              required
              placeholder="Enter URL"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
            />
          </div>

          <div className="space-y-2">
            <Label>Display Text (optional)</Label>
            <Input
              type="text"
              placeholder="Enter display text"
              value={text}
              onChange={(e) => setText(e.target.value)}
            />
          </div>

          <div className="flex items-center space-x-2">
            <Label>Open in New Tab</Label>
            <Switch checked={isNewTab} onCheckedChange={setIsNewTab} />
          </div>

          <div className="flex justify-end space-x-2">
            <Button type="button" onClick={handleSave}>
              Save
            </Button>
          </div>
        </div>
      </div>
    )
  },
)

LinkEditBlock.propTypes = {
  onSave: PropTypes.func.isRequired,
  defaultIsNewTab: PropTypes.bool,
  defaultUrl: PropTypes.string,
  defaultText: PropTypes.string,
  className: PropTypes.string,
}

LinkEditBlock.displayName = 'LinkEditBlock'

export default LinkEditBlock
